import React, { FC } from "react";
import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";

export interface PageSellerGuidesProps {
  className?: string;
}

const AboutUs: FC<PageSellerGuidesProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageSellerGuides overflow-hidden relative ${className}`}
      data-nc-id="PageSellerGuides"
    >
      <Helmet>
        <title>За нас - TryBuy.club</title>
      </Helmet>

      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <div className="py-16 lg:py-28 space-y-8 lg:space-y-12">
          <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900">За нас</h2>

          <p>
            Добре дошли в TryBuy.club – платформата, създадена да революционизира начина, по който
            хората инвестират в хотелски имоти по целия свят. Независимо дали сте купувач, който
            търси инвестиционни възможности, или собственик на хотел, който желае да продава имоти в
            рамките на своя хотел, ние предлагаме лесна за използване платформа, която свързва
            купувачи и продавачи.
          </p>

          <p>
            Нашата мисия е да изградим глобална мрежа, която премахва бариерите между купувачи и
            продавачи, като същевременно предоставя интуитивно и сигурно изживяване за всички
            участници. Вярваме, че инвестициите в хотелски имоти трябва да бъдат достъпни, ясни и
            сигурни.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">За купувачи</h3>

          <p>
            <strong>Открийте и инвестирайте в хотелски имоти по целия свят</strong>
          </p>
          <p>
            TryBuy.club предлага вълнуваща възможност за инвеститорите да открият уникални хотелски
            имоти за продажба. Независимо дали искате да закупите един имот или да диверсифицирате
            инвестиционното си портфолио, нашата платформа ви помага да намерите най-добрите
            възможности.
          </p>

          <p>
            <strong>Резервации</strong>
          </p>
          <p>
            След като намерите подходящия имот, можете да резервирате престой в хотела преди да
            инвестирате. Това ви позволява да се запознаете с имота отблизо и да се уверите, че
            отговаря на вашите цели.
          </p>

          <p>
            <strong>Свържете се</strong>
          </p>
          <p>
            Платформата ни ви позволява директно да се свързвате със собственици и представители на
            хотели. Можете да задавате въпроси и да получавате отговори в реално време, за да
            вземете информирано решение.
          </p>

          <p>
            <strong>Партньорски платформи</strong>
          </p>
          <p>
            Работим с утвърдени платформи за резервации като Booking.com и други, за да ви улесним
            да резервирате престой в имотите, които разглеждате. Така комбинираме сигурността на
            добре познати услуги с възможността за инвестиция.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">
            За продавачи и хотели
          </h3>

          <p>
            <strong>Разширете обхвата си и публикувайте своя имот</strong>
          </p>
          <p>
            За хотелите и продавачите TryBuy.club предлага уникална възможност да представят и
            продават имоти на глобална аудитория. Ние ви помагаме да достигнете до инвеститори,
            които търсят нови възможности.
          </p>

          <p>
            <strong>Представете своя хотел</strong>
          </p>
          <p>
            Представянето на вашия хотел в TryBuy.club е лесен и ефективен начин да покажете имота
            си. Платформата ни ви дава възможност да акцентирате върху характеристиките и
            инвестиционния потенциал, за да привлечете подходящите купувачи.
          </p>

          <p>
            <strong>Създайте обява</strong>
          </p>
          <p>
            Просто създайте акаунт и публикувайте имота си с детайлна информация и висококачествени
            снимки. След като бъде публикуван, имотът ви ще бъде видим за инвеститори по целия свят.
          </p>

          <p>
            <strong>Комуникация</strong>
          </p>
          <p>
            Общувайте директно с потенциални купувачи чрез платформата. Ще имате възможност да
            отговаряте на въпроси, да уговаряте огледи и да обсъждате потенциала на имота с
            квалифицирани инвеститори.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">
            За купувачи и продавачи
          </h3>

          <p>
            <strong>Присъединете се към доверена общност</strong>
          </p>
          <p>
            Независимо дали сте купувач, който търси доходоносна инвестиция, или продавач, който
            търси подходящи инвеститори, TryBuy.club е вашето място. Ние предлагаме надежден пазар,
            където купувачи и продавачи се свързват, сътрудничат и сключват сделки.
          </p>

          <p>
            <strong>Лесни транзакции</strong>
          </p>
          <p>
            Нашата платформа опростява процеса на покупка и продажба чрез сигурна и прозрачна
            комуникация в реално време, правейки целия процес бърз и безпроблемен за двете страни.
          </p>

          <p>
            <strong>Глобален обхват</strong>
          </p>
          <p>
            С глобална аудитория от купувачи и продавачи, TryBuy.club предлага уникална възможност
            да изследвате международни инвестиции и да разширите контактите си на пазара на имоти.
          </p>

          <p>
            В TryBuy.club сме ангажирани да направим вашето инвестиционно изживяване възможно
            най-лесно и удовлетворяващо. Присъединете се още днес и станете част от глобалната
            революция в инвестициите в хотелски имоти.
          </p>
        </div>

        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="PageSellerGuides_" />
        </div>

        <SectionSubscribe2 />
      </div>
    </div>
  );
};

export default AboutUs;
